module.exports = __webpack_public_path__ + "fonts/Avenir-Roman.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Avenir/Avenir-Roman.woff
// module id = 3477
// module chunks = 0